import queryString from "query-string";
import { IView, UrlQueryParams } from "store/types";

const view: IView = {
  commentsScroll: false,
  dealRedirect: null,
  reportDealView: {
    id: null!,
    title: ""
  },
  notificationScroll: {
    scrollToAnswer: "off"
  },
  shareDialog: null,
  leftSlider: null,
  scrollToQuestion: false,
  windowSize: {
    height: window.innerHeight,
    width: window.innerWidth
  },
  emailBoxUpdate: false,
  error409: "",
  cruchbaseDrawerState: false,
  cryptoCurrencyDrawerState: false,
  createManyMeasureData: null,
  selectedQuestion: null,
  quickViewAddNewLine: false,
  isDealCharBarOpen: false,
  sidebarState: false
};

export default (): IView => {
  const filteredEmail = location.search.replace(/(email.+)\+/g, "%2B");
  const queryParams: UrlQueryParams = queryString.parseUrl(filteredEmail).query;
  const viewQueries = queryParams.view && JSON.parse(queryParams.view);
  //ADD RESET QUERIES ACTION to reset VIEW PART OF STORE

  return {
    ...view,
    ...viewQueries
  };
};
